import React, { useEffect, useState } from 'react';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';

import background1 from '../public/img/background1.png';
import list1 from '../public/img/list1.png';
import list2 from '../public/img/list2.png';
import list3 from '../public/img/list3.png';
import list4 from '../public/img/list4.png';
import list5 from '../public/img/list5.png';
import background2 from '../public/img/background2.png';
import background3 from '../public/img/background3.png';
import personel from '../public/img/personel.png';
import personne2 from '../public/img/personne2.png';
import LogoBlanc from '../public/img/ecosystem.png';
import LogoColor from '../public/img/LogoColor.png';
import Logo1 from '../public/img/edf.png';
import Logo2 from '../public/img/care.png';
import Logo3 from '../public/img/danone.png';
import Logo4 from '../public/img/giz.png';
import { Layout, Form, Input, Button, Modal } from 'antd';
import Cookies from 'js-cookie';
import nextConnect from 'next-connect';
import { redirect } from 'next/dist/server/api-utils';
import Footer from '../components/Footer';

const HeaderD = () => {
  const [login, setLogin] = useState(false);
  const [modal2Open, setModal2Open] = useState(false);
  const [isGranted, setIsGranted] = useState(false);
  const [isValidEmail, setIsValidEmail] = useState();
  const [emailExist, setEmailExist] = useState('');
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const screens = useBreakpoint();
 
  // fetch email data and compare if is already exist
  const createUser = async (user) => {
    return new Promise((resolve, reject) => {
      fetch('/api/email', {
        method: 'post',
        body: JSON.stringify({
          firstName: user.firstName,
          lastName: user.lastName,
          compagny: user.compagny,
          email: user.email,
          position: user.position
        }),
        headers: {
          Accept: 'application/json, text/plain, */*',
          'Content-Type': 'application/json'
        }
      })
        .then((res) => {
          if (res.status === 200) {
            resolve(res.json());
          } else {
            reject(res);
          }
        })
        .catch((err) => reject(err));
    });
  };
  const onFinish = (values) => {
    if (values) {
      setLoading(true);
      Cookies.set('user', values.email);
      createUser(values)
        .then(() => {
          setModal2Open(true);
          setIsGranted(true);
          setLogin(true);
          setIsValidEmail(true);
          console.log('access granted');
          setLoading(false);
          form.resetFields();
        })
        .catch((err) => {
          setIsValidEmail(false);
          setLoading(false);
          setEmailExist('Email already registered');
        });
    } else {
      console.log('access denied');
      setLoading(false);
    }
  };
  // modal use effect
  useEffect(() => {
    const user = Cookies.get('user');
    if (loading) {
      setModal2Open(true);
    }
  }, [modal2Open]);

  useEffect(() => {
    const user = Cookies.get('user');
    if (user) {
      setIsGranted(true);
    }
  }, []);
  useEffect(() => {
    if (!isGranted) {
      setEmailExist('');
    }
  }, [emailExist]);
  return (
    <div className="container1">
      <img src={LogoBlanc.src} width="15%" />
      <div className="background-text">
        <h1>Webinar</h1>
        <h2>
          Putting smallholder farmers at the center of sustainable food systems:{' '}
        </h2>
        <h2>a case study of North African dairy farmers</h2>
      </div>

      <div className="staff-pics">
        {screens.sm && <img className="image" src={personel.src} alt="logo" />}
      </div>
      <div className="form" style={{ color: 'white', fontWeight: 'bold' }}>
        <p
          style={{
            marginBottom: '0px'
          }}
        >
          March | 20th
        </p>
        <div
          style={{
            width: screens.sm ? '100%' : '50%',
            textAlign: 'center',
            marginBottom: '20px'
          }}
        >
          <p>3:00-4:00pm CET · 9:00-10:00am CST · 10:00-11:00am EST</p>
        </div>
        <p>Register here</p>
        {
          <Form onFinish={onFinish} className="formulaire" form={form}>
            <Form.Item
              name="firstName"
              rules={[
                {
                  required: true,
                  message: 'Please input your first name!'
                }
              ]}
            >
              <Input type="text" placeholder="First Name*" />
            </Form.Item>
            <Form.Item
              name="lastName"
              rules={[
                {
                  required: true,
                  message: 'Please input your last name!'
                }
              ]}
            >
              <Input type="text" placeholder="Last Name*" />
            </Form.Item>
            <Form.Item
              name="compagny"
              rules={[
                {
                  required: true,
                  message: 'Please input your compagny!'
                }
              ]}
              style={{ color: 'red' }}
            >
              <Input type="text" placeholder="Company*" />
            </Form.Item>
            <Form.Item
              name="email"
              // validateStatus={isValidEmail && 'error'}
              // help=
              rules={[
                {
                  validator: async (rule, value) => {
                    console.log(value);
                    if (!value) {
                      return Promise.reject('Please input your email!');
                    }
                    if (value.indexOf('@') === -1) {
                      return Promise.reject('Please input a valid email!');
                    }
                    if (value.indexOf('') === -1) {
                      setEmailExist('');
                    }
                  }
                }
              ]}
            >
              <Input
                type="text"
                id="emailInput"
                placeholder="Email*"
                onChange={(e) =>
                  e.target.value.length === 0 && setEmailExist('')
                }
              />
            </Form.Item>
            {emailExist && (
              <p
                style={{
                  color: 'white',
                  textAlign: 'center',
                  fontWeight: 'bold'
                }}
              >
                {emailExist}
              </p>
            )}

            <Form.Item name="position">
              <Input type="text" placeholder="Position" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" loading={loading}>
                Sign up
              </Button>
            </Form.Item>
          </Form>
        }
        <Modal
          title="Vertically centered modal dialog"
          centered
          footer={null}
          open={modal2Open}
          onOk={() => setModal2Open(false)}
          onCancel={() => setModal2Open(false)}
        >
          <p>You have successfully registered to Danone Ecosystem's webinar!</p>
          <p>
            You will soon receive an official invitation to book a slot within
            your agenda.
          </p>
          <p
            style={{
              margin: '0'
            }}
          >
            Best regards,
          </p>
          <p>Danone Ecosystem Team</p>
          <img src={LogoColor.src} width="30%" />
        </Modal>
        {/* {login && (
          <Form onFinish={onLogin}>
            <Form.Item
              name="email"
            >
              <Input type="email" placeholder="Email" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Sign in
              </Button>
            </Form.Item>
          </Form>
        )} */}
      </div>
      <style jsx>{`
        .container1 {
          position: relative;
          background-image: url(${background1.src});
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          margin-bottom: 12px;
        }

        .container1 > img {
          float: right;
          margin: 30px;
        }
        h1 {
          font-size: 45px;
          color: white;
          margin: 0 0 0 20px;
        }
        h2 {
          font-size: 20px;
          color: white;
          margin: 0 0 0 20px;
          font-family: 'Comfortaa', sans-serif !important;
          line-height: 28px;
        }
        .background-text {
          margin: 50px 0 90px 0;
        }
        .staff-pics {
          max-height: calc(100% + 32px);

          width: 100%;
          display: flex;
          flex-direction: row-reverse;
          justify-content: start;
          text-align: center;
          color: white;
        }
        .form {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: ${screens.md ? '410px' : '100%'};
          margin: ${screens.md ? '15px 60%' : '0 auto'};
        }

        .formulaire {
          width: 250px !important;
          text-align: center;
        }
        .formulaire span {
          text-align: center !important;
        }
        .formulaire > .ant-form-item {
          margin-bottom: 0 !important;
        }
        .ant-input {
          border-radius: 50px !important;
        }
        .formInput {
          width: 270px;
        }
        .form text {
          color: white !important;
          width: 100%;
          text-align: center;
        }
        .image {
          display: ${screens.md ? 'block' : 'none'};
          position: absolute;
          left: 0;
          bottom: 0;
          max-height: calc(100% - 10px);
          max-width: 48%;
        }
      `}</style>
    </div>
  );
};
const Content = () => {
  const screens = useBreakpoint();
  const items = [
    {
      name: 'Hazem Fahmy',
      company: 'Care Egypt Foundation ',
      position: 'Executive director ',
      avatar: list1.src
    },
    {
      name: 'Britt Groosman',
      position: 'Vice President, Climate-Smart Agriculture',
      company: 'Environmental Defense Fund',
      avatar: list2.src
    },

    {
      name: 'Emmanuel Marchant',
      position: 'GM sustainable milk Africa',
      company: 'Danone',
      avatar: list3.src
    },
    {
      name: 'François-Henri Derrien',
      position: 'Africa Expert',
      company: 'Danone Ecosystem',
      avatar: list4.src
    },
    {
      name: 'Alexandre Kouchner',
      position: 'Jounalist',
      company: 'Moderator',
      avatar: list5.src
    }
  ];
  return (
    <div className="container">
      <h1>Farm visit | Impact spotlight</h1>
      <ul>
        {items.map((item, index) => (
          <li key={index}>
            <div className="list-item">
              <img src={item.avatar} alt={item.name} />
              <div className="list-item-text">
                <p>{item.name}</p>
                <p>{item.position}</p>
                <p>{item.company}</p>
              </div>
            </div>
          </li>
        ))}
      </ul>
      <style jsx>{`
        .container {
          background-image: url(${background2.src});
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          padding: 32px;
          margin-bottom: 12px;
        }
        h1 {
          font-size: 32px;
          color: white;
          text-align: center;
          margin: 0 0 32px;
        }
        ul {
          list-style-type: none;
          padding: 0;
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
        }
        li {
          flex: ${screens.md ? '33.33%' : '100%'};
          max-width: ${screens.md ? '33.33%' : '100%'};
          margin: 0 0 16px;
        }
        .list-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
        .list-item img {
          max-width: 120px;
          height: auto;
          margin: 0 auto 16px;
        }
        .list-item p {
          font-size: 14px;
          line-height: 1.3;
          color: white;
          font-weight: 500;
          text-align: center;
          margin: 0;
        }
      `}</style>
    </div>
  );
};
const Content2 = () => {
  const screens = useBreakpoint();
  return (
    <div className="container">
      <div className="text">
        <p>
          Smallholder farmers represent 80% of farmers in North Africa. They
          have a fundamental role in delivering sustainable food systems, but as
          underscored by the Food and Agriculture Organization, many experience
          poverty, food insecurity, and limited access to markets and services.
        </p>
        <p>
          In this webinar, we will explore the following questions while looking
          at concrete cases in North Africa:
        </p>
        <ul>
          <li>
            How to support North African smallholders in shifting to farming
            models that are both sustainable and economically viable?
          </li>
          <li>What do these models look like ?</li>
          <li>What resources and partnerships are needed to achieve them? </li>
          <li>
            How optimizing productivity can improve farmer livelihoods and
            ensure nutritional security while supporting lower methane emissions
            per unit of milk?
          </li>
        </ul>
        <p>
          Supported by GIZ, Danone, Care International and local actors Danone
          Ecosystem projects in Morocco, Egypt and Algeria have helped more than
          11,500 smallholders increase their revenue while improving
          environmental sustainability. In Algeria for example, subsistence
          farmers have increased their revenue by 34% while reducing their
          carbon footprint by 4% in 1 year.
        </p>
        {/* <p>
          These initiatives launched in North Africa helped to increase farmers’
          revenues while improving their environmental sustainability. In
          Algeria for example, subsistence farmers have increased their revenue
          by 34%. Algerian smallholder farmers also managed to reduce their
          carbon footprint by 4% in 1 year.
        </p> */}
      </div>
      <img className="image" src={personne2.src} alt="background" />
      <style jsx>{`
        .container {
          position: relative;
          background-color: #5771bb;
          padding: 32px;
          margin-bottom: 12px;
        }
        .text {
          font-family: 'Poppins', sans-serif !important;
          padding-right: ${screens.md ? '33%' : '0'};
          letter-spacing: 1px;
        }
        .image {
          display: ${screens.md ? 'block' : 'none'};
          position: absolute;
          right: 0;
          bottom: 0;
          max-height: calc(100% + 32px);
          max-width: 36%;
        }
        p,
        li {
          text-align: justify;
          color: white;
        }
      `}</style>
    </div>
  );
};

// export const Footer = () => {
//   const screens = useBreakpoint();
//   const items = [
//     {
//       name: 'giz',
//       link: 'https://www.giz.de/en/html/index.html',
//       logo: Logo4.src
//     },
//     {
//       name: 'care',
//       link: 'https://www.caremaroc.org/',
//       logo: Logo2.src
//     },
//     {
//       name: 'danone',
//       link: 'https://www.danone.com/fr.html',
//       logo: Logo3.src
//     },
//     {
//       name: 'ecosystem',
//       link: 'https://www.linkedin.com/company/danone-ecosystem/',
//       logo: LogoBlanc.src
//     },

//     {
//       name: 'edf',
//       link: 'https://www.edf.org/',
//       logo: Logo1.src
//     }
//   ];
//   return (
//     <div className="container">
//       <div>
//         <ul className="list">
//           {items.map((item, index) => (
//             <li key={index}>
//               <div className="list-item">
//                 <a href={item.link} target="_blank">
//                   <img src={item.logo} alt={item.name} />
//                 </a>
//               </div>
//             </li>
//           ))}
//         </ul>
//       </div>
//       <style jsx>{`
//         .container {
//           background-image: url(${background3.src});
//           background-size: cover;
//           background-repeat: no-repeat;
//           background-position: center;
//           padding: 32px 0 0;
//         }
//         ul {
//           list-style-type: none;
//           padding: 0 29px 0 0;
//           display: flex;
//           justify-content: space-evenly;
//           flex-wrap: wrap-reverse;
//         }
//         li {
//           flex: ${screens.md ? '33.33%' : '100%'};
//           max-width: ${screens.md ? '33.33%' : '100%'};
//           margin: 0 0 16px;
//         }
//         .list-item {
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           justify-content: center;
//         }
//         .list-item img {
//           max-width: 250px;
//           height: 58px;
//           margin: 0 auto 16px;
//         }
//         // .footer {
//         //   display: flex;
//         //   flex-direction: column;
//         //   // justify-content: space-between;
//         // }
//         // .footerTop {
//         //   display: flex;
//         //   justify-content: center;
//         //   // align-items: center;
//         //   margin-bottom: 32px;
//         // }
//         // .footerTop img {
//         //   max-width: 250px;
//         //   height: auto;
//         // }
//         // .list {
//         //   display: flex;
//         //   flex-direction: ${screens.md ? 'row' : 'column'};
//         //   justify-content: space-between;
//         //   padding: 0;
//         //   flex-wrap: wrap;
//         // }
//         .footerBottom {
//           display: flex;
//           // flex-direction:  ${screens.md ? 'row' : 'row'};
//           justify-content: center;
//           align-items: center;
//           margin-bottom: 32px;
//         }
//         .footerBottom img {
//           max-width: 250px;
//           height: auto;
//         }
//         .list .footerBottom img:last-of-type {
//           border-radius: 60px;
//         }
//       `}</style>
//     </div>
//   );
// };

const index = () => {
  return (
    <Layout
      style={{
        width: '100%',
        maxWidth: '1024px',
        margin: '0 auto'
      }}
    >
      <HeaderD />
      <Content />
      <Content2 />
      <Footer />
    </Layout>
  );
};

export default index;
